import {
  GET_USER_FROM_SESSION,
  UPDATE_AVAILABLE_TOOLS,
  UPDATE_USER_LATEST_ROLES,
  UPDATE_USER
} from 'actions/Types';

export default (state = null, action) => {
  if (action.type === `${GET_USER_FROM_SESSION}_SUCCESS`) {
    return action.payload;
  }

  if (action.type === `${UPDATE_USER}_SUCCESS`) {
    return action.payload;
  }

  if (action.type === `${UPDATE_USER_LATEST_ROLES}_SUCCESS`) {
    return action.payload;
  }

  if (action.type === `${UPDATE_AVAILABLE_TOOLS}_SUCCESS`) {
    const { availableTools, eventId, userId } = action.payload;
    const { _id, events } = state;
    if (userId === _id) {
      const eventRoleIndex = events.findIndex(
        eventRole => eventRole.event?.toString() === eventId?.toString()
      );
      if (eventRoleIndex !== -1) {
        state.events[eventRoleIndex].availableTools = availableTools;
      }
    }
    return Object.assign({}, state);
  }

  return state;
};
